import React from "react";
import { Route, Routes } from "react-router-dom";
import { RoutesPaths } from "./constant";
import Login from "../Pages/Auth/Login";
import VerifyOtp from "../Pages/Auth/VerifyOtp";
import Dashboard from "../Pages/Dashboard";
import TaxpayerList from "../Pages/Taxpayers/TaxpayerList";
import TaxpayerDetail from "../Pages/Taxpayers/TaxpayerDetail";
import DataQuality from "../Pages/DataQuality";
import DuplicateRecords from "../Pages/DataQuality/DuplicateRecords";
import RiskCompliance from "../Pages/Risk";
import Relationships from "../Pages/Relationships";
import AuditIntelligence from "../Pages/AuditIntelligence";
import NifRegistration from "../Pages/NifRegistration";
import DataSources from "../Pages/DataIntegration/DataSources";
import ImportData from "../Pages/DataIntegration/ImportData";
import Synchronization from "../Pages/DataIntegration/Synchronization";
import Reports from "../Pages/Reports";
import Security from "../Pages/Security";
import UserManagement from "../Pages/UserManagement";
import Settings from "../Pages/Settings";

export default function RouteComponent() {
  return (
    <>
      <Routes>
        <Route exact path={RoutesPaths.LOGIN} element={<Login />} />
        <Route exact path={RoutesPaths.VERIFY_OTP} element={<VerifyOtp />} />
        <Route exact path={RoutesPaths.DASHBOARD} element={<Dashboard />} />
        <Route exact path={RoutesPaths.TAXPAYERS} element={<TaxpayerList />} />
        <Route
          exact
          path={RoutesPaths.DATA_QUALITY}
          element={<DataQuality />}
        />
        <Route
          exact
          path={RoutesPaths.DQ_DUPLICATES}
          element={<DuplicateRecords />}
        />
        <Route exact path={RoutesPaths.RISK} element={<RiskCompliance />} />
        <Route
          exact
          path={RoutesPaths.RELATIONSHIPS}
          element={<Relationships />}
        />
        <Route exact path={RoutesPaths.AUDIT} element={<AuditIntelligence />} />
        <Route
          exact
          path={RoutesPaths.NIF_REGISTRATION}
          element={<NifRegistration />}
        />
        <Route exact path={RoutesPaths.DI_SOURCES} element={<DataSources />} />
        <Route exact path={RoutesPaths.DI_IMPORT} element={<ImportData />} />
        <Route exact path={RoutesPaths.DI_SYNC} element={<Synchronization />} />
        <Route exact path={RoutesPaths.REPORTS} element={<Reports />} />
        <Route exact path={RoutesPaths.SECURITY} element={<Security />} />
        <Route
          exact
          path={RoutesPaths.USER_MANAGEMENT}
          element={<UserManagement />}
        />
        <Route exact path={RoutesPaths.SETTINGS} element={<Settings />} />
        <Route
          exact
          path={RoutesPaths.TAXPAYER_DETAIL}
          element={<TaxpayerDetail />}
        />
      </Routes>
    </>
  );
}
